import postDiscardActionsSelector from 'app/App/selectors/postDiscardActions';
import postSaveActionsSelector from 'app/App/selectors/postSaveActions';
import { saveAndVisitComponentThunk } from 'app/EditorPane/thunks';
import { saveAndVisitPageThunk } from 'app/Explorer/thunks';
import isPageSelectedSelector from 'app/Page/selectors/isPageSelected';

import { hideUnsavedChangesConfirmationModal } from './actions';

/**
 * discard changes and continue with action
 * @returns {Function} thunk
 */
export const onDiscardThunk = () => (dispatch, getState) => {
  const postDiscardActions = postDiscardActionsSelector(getState());
  dispatch(hideUnsavedChangesConfirmationModal());
  postDiscardActions.forEach(action => {
    dispatch(action);
  });
};

/**
 * save the current page/component and continue with action
 * @returns {Function} thunk
 */
export const onSaveThunk = () => async (dispatch, getState) => {
  const state = getState();
  const postSaveActions = postSaveActionsSelector(getState());
  const isPageSelected = isPageSelectedSelector(state);
  let response;

  // We need to call save and visit to show the saved page in case action is cancelled later
  // for example creating new component or new page can be cancelled from modal nevermind click.
  if (isPageSelected) {
    response = await dispatch(saveAndVisitPageThunk());
  } else {
    response = await dispatch(saveAndVisitComponentThunk());
  }
  dispatch(hideUnsavedChangesConfirmationModal());
  if (response) {
    postSaveActions.forEach(action => {
      dispatch(action);
    });
  }
};
